module.exports = __webpack_public_path__ + "static/img/banner-wencui.4530ec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-wencui.jpg
// module id = D+Iq
// module chunks = 0